import Vue from 'vue'
import router from '@/router' //路由
import store from '@/store'; //Vuex
import { getInfo } from '@/api/public' //获取用户登录信息
Vue.prototype.$store = store;

Vue.prototype.baseURL = process.env.NODE_BASE_URL

// 需要登录才能访问的路由路径前缀
const authRequiredPaths = [
  '/mycardhobby',  //个人中心
  '/vault', // vault
  '/pay/', // 支付
  '/messages', // 消息
  '/feedback', // 评价
]

router.beforeEach((to, from, next) => {
  //获取买家对应货币符号
  store.dispatch("getUserForSymbol", to.name)

  // 登录验证：检查目标页面是否需要登录
  const requiresAuth = authRequiredPaths.some(path => to.path.startsWith(path))
  if (requiresAuth) {
    const userInfo = getInfo()
    if (!userInfo) {
      // 未登录，记录目标路径并标记为鉴权重定向，登录成功后自动回跳
      window.localStorage.setItem('toLink', "/#" + to.path)
      window.localStorage.setItem('authRedirect', '1')
      next({ name: 'Login' })
      return
    }
  }

  if (to.name == 'Login') {
    // 若是鉴权守卫触发的重定向，保留目标路径；否则按原有逻辑记录来源
    if (window.localStorage.getItem('authRedirect') !== '1') {
      if (from.name != "Register" && from.name != "Forgot") {
        window.localStorage.setItem('toLink', "/#" + from.path)
      } else {
        window.localStorage.setItem('toLink', "/")
      }
    }
    window.localStorage.removeItem('authRedirect')
  }
  const nextPage = () => {
    // store.dispatch("userLog");
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    // window.pageYOffset = 0//ie11 有问题

    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next()
  }

  const toName = () => {
    if (to.name == 'home') {
      store.dispatch("getCookiesCategory")
      store.dispatch("checkUser")
    }
    if (to.name == 'search') {
      store.dispatch("setSaveTime")
    }
    if (to.name == 'Account Settings') {
      store.dispatch("checkUser")
    }
  }


    //检查有没有活动的token
  const isActivityToken = () => {
    if (store.state.activityToken) {
      nextPage()
    } else {
      store.dispatch('getActivityToken').then(() => {
        nextPage()
      }).catch(() => {
        nextPage()
      })
    }
  }
  // 检查有没有官方商城的token
  if (store.state.storeToken) {
    toName()
    isActivityToken()
  } else {
    store.dispatch('getStoreToken').then(res => {
      toName()
      if (res.Result == 1) {
        isActivityToken()
      } else {
        nextPage()
      }
    }).catch(() => {
      nextPage()
    })
  }
})


// WEBPACK FOOTER //
// ./src/utils/route_guards.js